import { render, staticRenderFns } from "./PurchaseListItemRow.vue?vue&type=template&id=1278ed76&scoped=true"
import script from "./PurchaseListItemRow.vue?vue&type=script&lang=ts"
export * from "./PurchaseListItemRow.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseListItemRow.vue?vue&type=style&index=0&id=1278ed76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278ed76",
  null
  
)

export default component.exports